import React, { useEffect, useState,useRef } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { compareAsc, format } from 'date-fns'
import moment from "moment";
import Skills from "./Skills/Skills";
import {httpCreateUserGroup} from "../Employee/Skills/api/calls";
function EditEmployeeCom(props) {

    const empshiftRef = useRef();
    let navigate = useNavigate();
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));

    const [skillData,setUserSkillData] = useState([]);

    const [salutation, setSalutation] = useState('');
    const [fname, setFname] = useState('');
    const [mname, setMname] = useState('');
    const [lname, setLname] = useState('');
    const [gargen, setGargen] = useState('');
    const [gender, setGender] = useState('');
    const [dateofbirth, setDateofbirth] = useState('');
    const [marriage, setMarriage] = useState('');
    const [bloodgroup, setBloodgroup] = useState('');
    const [nationality, setNationality] = useState('');
    const [adhaarname, setAdhaarname] = useState('');
    const [adhaarnumber, setAdhaarnumber] = useState('');
    const [pancardnumber, setPancardnumber] = useState('');

    const [company, setCompany] = useState('');
    const [empstatus, setEmpstatus] = useState('1');
    const [empcode, setEmpcode] = useState('');

    const [division, setDivision] = useState('');
    const [department, setDepartment] = useState('');
    const [designation, setDesignation] = useState('');
    const [empcategory, setEmpcategory] = useState('');
    const [noticeperiod, setNoticeperiod] = useState('');

    const [dateofjoining, setDateofjoining] = useState('');
    const [probation_period, setProbation_period] = useState('');
    const [confirmationdate, setConfirmationdate] = useState('');

    const [ctc, setCtc] = useState('');
    const [salaryType, setSalaryType] = useState('');
    const [bankname, setBankname] = useState('');
    const [accountnumber, setAccountnumber] = useState('');
    const [ifsc, setIfsc] = useState('');
    const [pfapplicable, setPfapplicable] = useState('');
    const [pfnumber, setPfnumber] = useState('');
    const [pfgroup, setPfgroup] = useState('');
    const [emp_id, setEmp_id] = useState('');

    const [color, setColor] = useState('');
    const [errmsg, setErrmsg] = useState('');
    const [buttonstatus, setbuttonstatus] = useState(true);
    const [uan_number, setUan_number] = useState('');
    const [pt_applicable, setPt_applicable] = useState('');
    const [timezone, setTimezone] = useState('');
    const [systemRole, setSystemRole] = useState('');
    const [role, setRole] = useState('');
    const [sub_role, setSub_Role] = useState('');
    const [depdata, setDepdata] = useState([]);
    const [roledata, setRoledata] = useState([]);
    const [comdata, setComdata] = useState([]);
    const [system_role, setSystem_role] = useState([]);
    const [persona_email, setPersonal_email] = useState('');
    const [contact_number, setContact_number] = useState('');
    const [errMsgShift, setErrMsgShift] = useState('');
    const [err, setErr] = useState('');
    // const [officialemailstatus, setOfficialemailstatus] = useState(true);
    const [reportingmanager,setreportingmanager] = useState('');
    const [shift, setShift] = useState('');
	const [shiftList, setShiftList] = useState([]);  

    const [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get('id')
    useEffect(() => {
        getCompanyList()
        getuserById()
        getDepartmentList()
        getSystemRole()
        getLocation()
        getReportingManager()
    }, []);


    const [reportimgManageList, setReportimgManageList] = useState([]);
	const getReportingManager = () => {
		const response = fetch(SERVER_URL + `api/common/manager_list`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},

			}).then(res => res.json())
			.then(data => {
				// console.log('setReportimgManageList')
				// console.log(data)
				// console.log('setReportimgManageList')
				setReportimgManageList(data.result)
			});
	}
    const getSystemRole = () => {
        const response = fetch(SERVER_URL + `api/common/sytem-role`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            }).then(res => res.json())
            .then(data => {
                setSystem_role(data.result)
            });
    }

    const getCompanyList = () => {
        const response = fetch(SERVER_URL + `api/common/company_list`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },

            }).then(res => res.json())
            .then(data => {
                setComdata(data.result)
            });
    }

    const getDepartmentList = (deptid) => {
        
        const response = fetch(SERVER_URL + `api/common/department_list`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            }).then(res => res.json())
            .then(data => {
                 setDepdata(data.result)
            });
    }

    function handleChange(deptid) {
        setRole(deptid)
        setDepartment(deptid)
        const response = fetch(SERVER_URL + `api/common/get_department_role`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    id: deptid,
                }),
            }).then(res => res.json())
            .then(data => {
                setRoledata(data.result)
            });
    }


    const getuserById = async () => { 
        const response = await fetch(SERVER_URL + `api/employee/edit`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    id: id
                }),
            })
            .then(res => res.json())
            .then(data => { 
                // console.log("===========data=============tttttt")
                // console.log(data.data)
                // console.log("=================data==============")
                if (data?.status == true) {
                    const response = data?.data;
                    setSalutation(response.salutation)
                    setFname(response.fname)
                    setMname(response.mname)
                    setLname(response.lname)
                    setGargen(response.guardian_name)
                    setGender(response.gender)
                    setContact_number(response.contact_no)
                    setPersonal_email(response.personal_email)
                    // setOfficialemailstatus(response.official_email_status)
                    setDateofbirth(moment(response.birthday).format('yyyy-MM-DD'))
                    setMarriage(response.marrige_status)
                    setBloodgroup(response.blood_group)
                    setNationality(response.nationality_type)
                    setAdhaarname(response.uid_name)
                    setAdhaarnumber(response.uid_no)
                    setPancardnumber(response.pan_no)

                    setCompany(response.comp_id)
                    setDivision(response.division)
                    setreportingmanager(response.reporting_manager)
                   // setDepartment(response.role)
                    // alert(response.role)

                    setRole(response.role)
                    setSub_Role(response.sub_role)
                    setEmpcode(response.user_code)
                    setEmpstatus(response.status)

                    setDateofjoining(moment(response.joining_date).format('yyyy-MM-DD'))
                    setProbation_period(response.probation_period)
                    // setConfirmationdate(response.hr_confirmationdate)
                    setConfirmationdate(response.hr_confirmationdate ? moment(response.hr_confirmationdate).format('yyyy-MM-DD') : '')
                   // setRole(response.system_role)

                    if (response?.role != '') {
                        handleChange(response?.role)
                    }
                    setDesignation(response.role_id)
                    setEmpcategory(response.user_type)
                    setNoticeperiod(response.noticeperiod)

                    setSalaryType(response.salary_type)
                    setCtc(response.ctc)
                    setBankname(response.bank_name)
                    setAccountnumber(response.account_no)
                    setIfsc(response.bank_ifsc)
                    setPfapplicable(response.pf_applicable)
                    setPfnumber(response.pf_no)
                    setPfgroup(response.pf_group)
                    setEmp_id(response.id)
                    setUan_number(response.uan_number)
                    setPt_applicable(response.pt_applicable)
                    setSystemRole(response.system_role_id)
                    setTimezone(response.time_zone)
                    setShift(response.shift)

                } else {
                    setErrmsg('Error! Something went wrong')
                    setbuttonstatus(false)
                }
            });
    }


    const handleEdituser = () => {
        const user_login_id = localStorage.getItem('userId')
        const date = new Date();
        const date_formate = format(date, 'yyyy-MM-dd HH:m:SS')
        const response = fetch(SERVER_URL + `api/employee/update`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    id: emp_id,
                    emailpersonal: persona_email,
                    salutation: salutation,
                    fname: fname,
                    mname: mname,
                    lname: lname,
                    gurgaon: gargen,
                    gender: gender,
                    timezone: timezone,
                    dateofbirth: dateofbirth,
                    marriage_status: marriage,
                    bloodgroup: bloodgroup,
                    nationality: nationality,
                    adhaarname: adhaarname,
                    adhaarnumber: adhaarnumber,
                    pancardnumber: pancardnumber,
                    comp: company,
                    division: division,
                    contact:contact_number,
                    //dept: department,
                    reporting_manager:reportingmanager,
                    empcode: empcode,
                    status: empstatus,
                    joiningdate: dateofjoining,
                    probation_period: probation_period,
                    confirmationdate: confirmationdate,
                    role: role,
                    sub_role:sub_role,
                    usertype: empcategory,
                    noticeperiod: noticeperiod,
                    salaryType: salaryType,
                    ctc: ctc,
                    bankname: bankname,
                    accountnumber: accountnumber,
                    ifsc: ifsc,
                    pfapplicable: pfapplicable,
                    pfnumber: pfnumber,
                    pfgroup: pfgroup,
                    pt_applicable: pt_applicable,
                    uan_number: uan_number,
                    systemRole: systemRole,
                    updated_on: date_formate,
                    updated_by: user_login_id,
                    shift:shift
                }),
            }).then(res => res.json())
            .then(data => {
                if (data.status === true) {
                    setErrmsg('Employee, Successfully uploaded')
                    setColor('green')
                    addUserSkill(emp_id)
                    setTimeout(function () {
                        navigate("/employeelist");
                    }, 1000);
                } else {
                    setErrmsg('Error! Something went wrong')
                    setbuttonstatus(false)
                    setColor('red')
                }
            })
    }
    const addUserSkill = (id) =>{
		if(skillData){
			const userSkill = {
				user_id:id,
				skillData
			}
			// console.log('user skill')
			// console.log(userSkill);
			httpCreateUserGroup(userSkill)
		}
	}
    const userSkillParentCallback = (userSkillChildData) =>{
		// console.log('userSkillChildData')
		// console.log(userSkillChildData)
		setUserSkillData(userSkillChildData)

	}
    const [locationlist, setLocationlist] = useState([])
	const getLocation = async (page) => {
		const response = await fetch(SERVER_URL + `api/common/time-zone-list`,
			{
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
			}).then(res => res.json())
			.then(data => { 
				if (data.status == true) {
					setLocationlist(data.result)
				}
			})
	}
useEffect(()=>{
    getShiftList() 
},[])
    const getShiftList = () => {
		const response = fetch(SERVER_URL + `api/common/getshiftlist`,
			{
				method: 'post',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
				body: JSON.stringify({
					emailpersonal: persona_email,
					city: '',
				}),
			}).then(res => res.json())
			.then(data => {
				setShiftList(data.result)
			})
	}
    return (
        <>
          
            <div className="page-header">
				<h1>Edit Employee</h1>
				<ul id="breadcrumbs" className="breadcrumb mb00">
					<li>
						<Link to="/dashboard">Dashboard </Link>
					</li>
					<li>
						<Link to='/employeelist'><span>/</span>Employee List </Link>
					</li>
					<li className="current">
						<span>/</span>Edit Employee
					</li>
				</ul>
			</div>

			<div className="row_bg">

            <div className="profile_wrapper mb30">
                <div className="nav" id="profile-tab" role="tablist" aria-orientation="vertical">

                    <a className="nav-link active" id="employmentprofile-tab" data-bs-toggle="tab" href="#employmentprofile" data-bs-target="#employmentprofile">
                        Employment Profile
                    </a>
                    <span className="middleline"></span>
                    <a className="nav-link" id="employmentspecifics-tab" data-bs-toggle="tab" href="#employmentspecifics" data-bs-target="#employmentspecifics">
                        Employment Specifics
                    </a>
                    <span className="middleline"></span>
                    <a className="nav-link" id="detail-tab" data-bs-toggle="tab" href="#detail" data-bs-target="#detail">
                        Other Detail
                    </a>
                    <span className="middleline"></span>
					<Link className="nav-link" id="skill-tab" data-bs-toggle="tab" href="#skillset" data-bs-target="#skillset">
						Skill Set
					</Link>
                </div>
            </div>
            <div className="tab-content" id="profile-tabContent">
                <div className="tab-pane fade show active" id="employmentprofile" role="tabpanel" aria-labelledby="employmentprofile-tab">
                    <div className="tab_content">
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Salutation</div>
                                    <div className="form-input col-md-8">
                                        <select value={salutation} onChange={(e) => { setSalutation(e.target.value) }} className="form-select">
                                            <option value=''>Select</option>
                                            <option value='1'>Mr</option>
                                            <option value='2'>Ms</option>
                                            <option value='3'>Mrs</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">First Name</div>
                                    <div className="form-input col-md-8">
                                        <input autoComplete="none" value={fname} onChange={(e) => { setFname(e.target.value) }} type="text" placeholder="Enter First Name" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Middle Name</div>
                                    <div className="form-input col-md-8">
                                        <input autoComplete="none" value={mname} onChange={(e) => { setMname(e.target.value) }} type="text" placeholder="Enter Middle Name" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Last Name</div>
                                    <div className="form-input col-md-8">
                                        <input autoComplete="none" value={lname} onChange={(e) => { setLname(e.target.value) }} type="text" placeholder="Enter Last Name" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Personal Email</div>
                                    <div className="form-input col-md-8">
                                        <input autoComplete="none" value={persona_email} onChange={(e) => { setPersonal_email(e.target.value) }} type="text" placeholder="Enter Personal Email" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Contact Number</div>
                                    <div className="form-input col-md-8">
                                        <input autoComplete="none" value={contact_number} onChange={(e) => { setContact_number(e.target.value) }} type="text" placeholder="Enter Contact Number" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Official Email </div>
                                    <div className="form-input col-md-8">
                                        <input checked={officialemailstatus ? 'checked' : ''} onChange={handleEmail}  type="checkbox" /> Create Yes/No
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Father/Husband</div>
                                    <div className="form-input col-md-8">
                                        <input value={gargen} autoComplete="none" onChange={(e) => { setGargen(e.target.value) }} type="text" placeholder="Enter Father/Husband Name" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Gender</div>
                                    <div className="form-input col-md-8">
                                        <select value={gender} onChange={(e) => { setGender(e.target.value) }} className="form-select">
                                            <option value='1'>Male</option>
                                            <option value='2'>Female</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Date Of Birth</div>
                                    <div className="form-input col-md-8">
                                        <input onChange={(e) => { setDateofbirth(e.target.value) }} type="date" className="form-control" name="" value={dateofbirth} placeholder="Select Date Of Birth" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Marital Status</div>
                                    <div className="form-input col-md-8">
                                        <select value={marriage} onChange={(e) => setMarriage(e.target.value)} className="form-select">
                                            <option value='1'>Married</option>
                                            <option value='2'>Unmarried</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Blood group</div>
                                    <div className="form-input  col-md-8">
                                        <input type="text" value={bloodgroup} onChange={(e) => setBloodgroup(e.target.value)} placeholder="Enter blood group" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Nationality</div>
                                    <div className="form-input col-md-8">
                                        <input type="text" value={nationality} onChange={(e) => setNationality(e.target.value)} placeholder="Enter Nationality" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Aadhaar Name </div>
                                    <div className="form-input col-md-8">
                                        <input type="text" value={adhaarname} onChange={(e) => setAdhaarname(e.target.value)} placeholder="Enter Aadhaar Card Name" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Aadhaar Number</div>
                                    <div className="form-input col-md-8">
                                        <input type="text" value={adhaarnumber} onChange={(e) => setAdhaarnumber(e.target.value)} placeholder="Enter Aadhaar Card Number" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Pan Number</div>
                                    <div className="form-input col-md-8">
                                        <input value={pancardnumber} onChange={(e) => setPancardnumber(e.target.value.toUpperCase())} type="text" placeholder="Enter Pan Card Number" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
									<div className="form-blk row">
										<div className="form-label col-md-4">Time Zone </div>
										<div className="form-input col-md-8">
											<select value={timezone} onChange={(e) => setTimezone(e.target.value)} className="form-select">
												<option value=''>Select Time Zone</option>
												{locationlist?.map((item, ind) =>
													<option value={item.location_id}>{item.timezone}</option>
												)}
											</select>
										</div>
									</div>
								</div>
                        </div>
                    </div>
                </div>

                <div className="tab-pane fade" id="employmentspecifics" role="tabpanel" aria-labelledby="employmentspecifics-tab">
                    <div className="tab_content">
                        <div className="tab_sub_ttl">Organization</div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Company</div>
                                    <div className="form-input col-md-8">
                                        <select value={company} onChange={(e) => setCompany(e.target.value)} className="form-select">
                                            <option value=''>Select Company</option>
                                            {
                                                comdata?.map((item, ind) => (
                                                    <option key={ind} value={item.id}>{item.name}</option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Division</div>
                                    <div className="form-input col-md-8">
                                        <select value={division} onChange={(e) => setDivision(e.target.value)} className="form-select">
                                            <option value=''>Select Division</option>
                                            {
                                                comdata?.map((item, ind) => (
                                                    <option key={ind} value={item.id}>{item.division}</option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Department</div>
                                    <div className="form-input col-md-8">
                                        <select value={role} onChange={e => handleChange(e.target.value)} className="form-select">
                                            <option value=''>Select Department</option>
                                            {
                                                depdata?.map((item, ind) => (
                                                    <option key={ind} value={item.id}>{item.name}</option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">System Role</div>
                                    <div className="form-input col-md-8">
                                        <select onChange={(e) => { setSystemRole(e.target.value) }} value={systemRole} className="form-select">
                                            <option >Select system role</option>
                                            {
                                                system_role?.map((item, ind) => (
                                                    <option key={ind} value={item.id}>{item.role}</option>
                                                ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="tab_sub_ttl">Employee Details</div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Employee Code</div>
                                    <div className="form-input col-md-8">
                                        <input type="text" value={empcode} onChange={(e) => setEmpcode(e.target.value)} placeholder="Enter Employee Code" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Employee Status</div>
                                    <div className="form-input col-md-8">
                                        <select value={empstatus} onChange={(e) => setEmpstatus(e.target.value)} className="form-select">
                                            <option value='1'>Active</option>
                                            <option value='2'>Inactive</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Date of joining </div>
                                    <div className="form-input col-md-8">
                                        <input type="date" value={dateofjoining} onChange={(e) => setDateofjoining(e.target.value)} className="form-control" placeholder="Select Date of joining" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Probation Period</div>
                                    <div className="form-input col-md-8">
                                        <input type="text" onChange={(e) => setProbation_period(e.target.value)} value={probation_period} placeholder="Enter Probation Period (Months)" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Confirmation Date </div>
                                    <div className="form-input col-md-8">
                                        <input value={confirmationdate} onChange={(e) => setConfirmationdate(e.target.value)} type="date" className="form-control" placeholder="Select Confirmation Date" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Designation </div>
                                    <div className="form-input col-md-8">
                                        <select value={sub_role} onChange={(e) => setSub_Role(e.target.value)} className="form-select">
                                            <option value=''>Select Designation </option>
                                            {
                                                roledata?.map((item, ind) => (
                                                    <option key={ind} value={item.id}>{item.name}</option>
                                                ))
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Employee Category</div>
                                    <div className="form-input col-md-8">
                                        <select value={empcategory} onChange={(e) => setEmpcategory(e.target.value)} className="form-select">
                                            <option value=''>Select Employee Category</option>
                                            <option value='1'>Onroll</option>
                                            <option value='2'>Contract</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Notice Period (Days) </div>
                                    <div className="form-input col-md-8">
                                        <input value={noticeperiod} onChange={(e) => setNoticeperiod(e.target.value)} type="text" placeholder="Enter Notice Period" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Reporting </div>
                                    <div className="form-input col-md-8">
                                    <select value={reportingmanager} className="form-select" onChange={(e)=>{setreportingmanager(e.target.value)}}>
												<option value=''>Select Reporting</option>
												{
													reportimgManageList.map((item, ind) => {
														return <option value={item.id}>{item.name}</option>
													})
												}
											</select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Final Reporting </div>
                                    <div className="form-input col-md-8">
                                        <div className="form-check formcheck1">
                                            <input className="form-check-input" type="checkbox" value="" id="level1" />
                                            <label className="form-check-label" htmlFor="level1">
                                                Level 1
                                            </label>
                                        </div>
                                        <div className="form-check formcheck1">
                                            <input className="form-check-input" type="checkbox" value="" id="level2" />
                                            <label className="form-check-label" htmlFor="level2">
                                                Level 2
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
									<div className="col-md-6">
										<div className="form-blk row">
											<div className="form-label col-md-4">Shift Time</div>
											<div className="form-input col-md-8">
												<span style={{ color: err }}>{errMsgShift}</span>
												<select ref={empshiftRef} value={shift} className="form-select" onChange={(e) => { setShift(e.target.value) }}>
													<option value=''>Select Shift</option>
													{
														shiftList.map((item, ind) => {
															return <option value={item.id}>{item.Name}</option>
														})
													}
												</select>
											</div>
										</div>
									</div>
								</div>
                    </div>
                </div>
                <div className="tab-pane fade" id="detail" role="tabpanel" aria-labelledby="detail-tab">
                    <div className="tab_content">
                        <div className="tab_sub_ttl">Remuneration</div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Salary Type</div>
                                    <div className="form-input col-md-8">
                                        <select value={salaryType} onChange={(e) => { setSalaryType(e.target.value) }} className="form-select">
                                            <option value=''>Select Salary Type</option>
                                            <option value='1'>Monthly Basis</option>
                                            <option value='2'>Daily Basis</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">CTC (Rs)</div>
                                    <div className="form-input col-md-8">
                                        <input type="text" value={ctc} onChange={(e)=>setCtc(e.target.value)} placeholder="Enter CTC" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="tab_sub_ttl">Bank Details</div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Salary Bank</div>
                                    <div className="form-input col-md-8">
                                        <select value={bankname} onChange={(e) => setBankname(e.target.value)} className="form-select">
                                            <option value=''>Select Salary Type</option>
                                            <option value='1'>HDFC Bank</option>
                                            <option value='1'>Federal Bank</option>
                                            <option value='1'>IDFC FIRST Bank</option>
                                            <option value='1'>RBL Bank</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">Account Number</div>
                                    <div className="form-input col-md-8">
                                        <input value={accountnumber} onChange={(e) => setAccountnumber(e.target.value)} type="text" placeholder="Enter Salary Account Number" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">IFSC Code</div>
                                    <div className="form-input col-md-8">
                                        <input value={ifsc} onChange={(e) => setIfsc(e.target.value.toUpperCase())} type="text" placeholder="Enter Salary IFSC Code" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">PF Applicable</div>
                                    <div className="form-input col-md-8">
                                        <select value={pfapplicable} onChange={(e) => setPfapplicable(e.target.value)} className="form-select">
                                            <option value=''>Select PF Applicable</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">PF Number</div>
                                    <div className="form-input col-md-8">
                                        <input value={pfnumber} onChange={(e) => setPfnumber(e.target.value)} type="text" placeholder="Enter PF Number" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">PF Group</div>
                                    <div className="form-input col-md-8">
                                        <select value={pfgroup} onChange={(e) => setPfgroup(e.target.value)} className="form-select">
                                            <option value=''>Select PF Group</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row mb25">
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">PT Applicable</div>
                                    <div className="form-input col-md-8">
                                        <select value={pt_applicable} onChange={(e) => { setPt_applicable(e.target.value) }} className="form-select">
                                            <option value=''>Select PT Group</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-blk row">
                                    <div className="form-label col-md-4">UAN Number</div>
                                    <div className="form-input col-md-8">
                                        <input type="text" value={uan_number ? uan_number : ''} onChange={(e) => { setUan_number(e.target.value) }} placeholder="Enter UAN Number" className="form-control form-control1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade" id="skillset" role="tabpanel" aria-labelledby="skill-tab">
						<div className="tab_content">
						<div className="tab_sub_ttl">Skills</div>
							<Skills department={department} userSkillParentCallback={userSkillParentCallback} page_action={'edit'} department_id={department} />
						</div>
					</div>
                <div className="tab_footer text-end">
                    <span style={{ color: color ? color : '' }}>{errmsg}</span>
                    <button onClick={handleEdituser} className="btn_5" style={{ display: buttonstatus == true ? '' : 'none' }} >Save</button>
                    <Link to='/employeelist' className="btn_6 ml10">Cancel</Link>
                </div>

            </div></div>
        </>
    )
}

export default EditEmployeeCom
